// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"44cd1a41","626":"edfd8378","651":"5ae4887c"}[chunkId] + ".chunk.js";
};